"use client";
import { type MotionValue, motion, useScroll, useTransform } from "motion/react";
import Image from "next/image";
import React, { useRef } from "react";
import dashboardScreenshot from "../../../../../public/images/dashboard.jpeg";

export const ScrollPad = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ["center end", "end end"],
    });
    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => {
            window.removeEventListener("resize", checkMobile);
        };
    }, []);

    const scaleDimensions = () => {
        return isMobile ? [0.8, 0.9, 0.9] : [1.05, 1, 1];
    };

    const rotate = useTransform(scrollYProgress, [0, 0.5, 1], [20, 0, 0]);
    const scale = useTransform(scrollYProgress, [0, 0.5, 1], scaleDimensions());
    const translate = useTransform(scrollYProgress, [0, 1], [0, isMobile ? -60 : -100]);
    const translateContent = useTransform(scrollYProgress, [0, 0.5, 1], [0, 0, -15]);

    return (
        <div
            className="relative flex h-full items-center justify-center overflow-hidden pt-24 pb-32 md:px-12 md:pt-36 md:pb-64"
            ref={containerRef}
        >
            <div
                className="relative w-full"
                style={{
                    perspective: "1000px",
                }}
            >
                <Header translate={translate} />
                <Card rotate={rotate} translate={translateContent} scale={scale} />
            </div>
        </div>
    );
};

const Header = ({ translate }: { translate: MotionValue<number> }) => {
    return (
        <motion.div
            style={{
                translateY: translate,
            }}
            className="div mx-auto max-w-5xl text-center"
        >
            <p className="mb-3 px-4 text-lg md:text-2xl">All Your Optimized Earnings in One Place</p>
            <h2 className="px-4 font-bold text-5xl md:text-6xl">Hello,Future</h2>
        </motion.div>
    );
};

const Card = ({
    rotate,
    scale,
    translate,
}: {
    rotate: MotionValue<number>;
    scale: MotionValue<number>;
    translate: MotionValue<number>;
}) => {
    const translateContent = useTransform(translate, (v) => `${v}%`);
    return (
        <motion.div
            style={{
                rotateX: rotate, // rotate in X-axis
                scale,
            }}
            className="-mt-12 mx-auto w-full max-w-5xl rounded-[30px] border-2 border-border bg-card p-4 shadow-2xl shadow-border/40 md:border-4 md:p-6"
        >
            <div className="h-full w-full overflow-hidden rounded-2xl bg-background p-2">
                <motion.div style={{ translateY: translateContent }} className="aspect-video w-full">
                    <div className="h-full w-full">
                        <Image alt="Dashboard Screenshot" src={dashboardScreenshot} />
                    </div>
                </motion.div>
            </div>
        </motion.div>
    );
};
